import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { WithdrawalBaseComponent } from '../withdrawal-base/withdrawal-base.component';
import { IonContent } from '@ionic/angular';
import { BalanceModel } from 'src/app/models/balance-model';
import { ConfigService } from 'src/app/services/config/config.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { ECheckModel } from '../../deposit/cashier-models/models';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';

@Component({
    selector: 'page-withdrawal-echeck',
    templateUrl: 'withdrawal-echeck.html',
    styleUrls : ['withdrawal-echeck.scss']
})
export class WithdrawalECheckPage extends WithdrawalBaseComponent implements OnInit {
    @ViewChild('Content') content: IonContent;

    public error = null;
    public btnDisabled = false;
    public hasAccount: boolean = false;
    public withdrawalForm: FormGroup;

    public amount: AbstractControl;
    public selectedAccount: AbstractControl;
    public customerAccountID: AbstractControl;
    public currency_code: AbstractControl;
    public payment_type_code: AbstractControl;
    public labels: DepositMainLabels;
    flatFee:number = 0;
    
    public accounts: any = [];
    public accountBalances: BalanceModel;

    public ssnValue: string;

    public maxACHAccounts;
    
    public showAddAccounts: boolean = false;

    constructor(
        // private logger: Logger,
        private config: ConfigService,
        private balanceProvider: AccountBalanceService,
        private cashierProvider: CashierService,
        private events: EventsService,
        private withdrawService:WithdrawalService,
        private successMessageService: SuccessMessageService,
        private cashierContentProvider:CashierContentService,
        private navigator:Navigator,
        public utils: UtilsService
        ) {

        super();
        this.labels = new ECheckModel();
        this.successMessageService.clearMessage();
        this.error = null;
    }

    ngOnInit() {
        this.maxACHAccounts = this.config.getConfig().FEATURE_ECHECK_NUM_ACCTS || 1;
        this.withdrawalForm = new FormGroup(
            {
                amount: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
                selectedAccount: new FormControl('', [Validators.required]),
                customerAccountID: new FormControl(''),
                currency_code: new FormControl(''),
                payment_type_code: new FormControl(''),
            }
        )

        this.amount = this.withdrawalForm.get('amount');
        this.selectedAccount = this.withdrawalForm.get('selectedAccount');
        
        
    }
    ionViewWillEnter() {
        this.onGetAccounts();
    }
    ionViewDidLoad() {
        console.log('ionViewDidLoad WithdrawalECheckPage');
    }

    ionViewDidEnter() {
        this.onGetBalance();
        this.withdrawService.getPayoutMethods().subscribe((res:any) =>{
            for(let paymentMethod of res){  
                if(paymentMethod?.PAYMENT_TYPE?.code === 'ACH'){
                    this.flatFee = paymentMethod.FLAT_FEE;
                    break;
                }
            }
        })
        this.cashierContentProvider
        .getPageConfig("echeck")
        .then((response: DepositMainLabels) => {
          this.labels = response;
        });
    }

    
    onInputChange(target) {
    }

    onGetBalance() {    

        this.balanceProvider.getBalance().subscribe(
            (balance: BalanceModel) => {
                if (balance) {
                    this.accountBalances = balance;                  
                }
            }
        );
        this.error = null;
    }

    onGetAccounts() {
        this.accounts = [];
        this.cashierProvider.callListAccounts().subscribe(
            (response) => {
                if (response.result) {
                    var tempAccounts: any = response.payload;
                    for (let index in tempAccounts) {
                        if (tempAccounts[index].paymentTypeCode == "ACH" && this.accounts.length < 4) {
                            this.accounts.push(tempAccounts[index]);
                            this.hasAccount = true;
                            // do not allow SIN update in this case 
                            if (typeof tempAccounts[index].accountAdditionalInfo3 != 'undefined') {
                                    this.ssnValue = tempAccounts[index].accountAdditionalInfo3;
                            }
                        }
                    }
                    this.showAddAccounts = true;
                }
                else {
                    // this.logger.error('Failed to get accounts');
                }
            }
        );
    }

    onAddNewAccount() {
        this.navigator.navigateTo("WithdrawalECheckAddPage", {multipleModals: true}, {ssnValue: this.ssnValue});
        return false;
    }

    submit() {
        this.btnDisabled = true;
        setTimeout(() => { this.onWithdraw() }, 200);
    }

    onWithdraw() {
        this.successMessageService.clearMessage();
        this.error = null;

        var accountIndex: AbstractControl = this.withdrawalForm.get("selectedAccount");
        
        this.withdrawalForm.get("customerAccountID").setValue(this.accounts[accountIndex.value].customerAccountID);
        this.withdrawalForm.get("currency_code").setValue(this.cashierProvider.customer.preferredCurrency.currencyCode);
        this.withdrawalForm.get("payment_type_code").setValue("ACH");
        
        // this.logger.log('onDeposit WithdrawalECheckPage', this.withdrawalForm.value);

        this.withdrawService.callWithdraw(this.withdrawalForm.value).subscribe(
            (response: any) => {
                // this.logger.log("callWithdraw response = ", response);
                if (response && !!response.result ) {

                    // send the withdrawal event
                    let depositEventData = {
                        customerId: this.cashierProvider.customer.customerId,
                        amount:     this.withdrawalForm.get('amount').value
                    }
                    setTimeout(() => this.events.publish('event:withdraw', depositEventData ), 2000);

                    this.amount.setValue('');
                    this.amount.markAsPristine();

                    this.successMessageService.setMessage('Your withdrawal request has been received.');
                    
                    this.balanceProvider.updateBalance();

                    this.content.scrollToTop();
                }
                this.btnDisabled = false;
            },
            (error) => {
                this.btnDisabled = false;
                // handle all deposit errors in base
                this.error = this.handleError(error);
                // this.logger.log("callWithdraw error = ", error);
            }
        )

        this.error = null;
    }
    radioChangedCard(e){
        this.selectedAccount = this.accounts[e.target.value];
    }
}